import { createFileRoute } from "@tanstack/react-router";
import { CreatePrestationPage } from "@/features/achats/components/prestations/CreatePrestationPage";

export const Route = createFileRoute("/_app/achats/prestations/create")({
  staticData: {
    title: "Nouvelle prestation",
    showInBreadcrumb: true,
  },
  component: CreatePrestationPage,
});
